<template>
    <div id="aside"
         class="app-aside modal nav-dropdown no-select"
         :class="{ 'folded md show-text': sidebar_folded }">
        <!-- fluid app aside -->
        <div class="left navside text-blackish"
             data-layout="column">
            <div class="navbar no-radius">
                <!-- brand -->
                <a class="navbar-brand mx-auto d-block">
                    <img :src="getLogo.logo"
                         v-if="!sidebar_folded"
                         alt=".">
                    <img :src="getLogo.logo_only"
                         v-else
                         alt=".">
                </a>
                <!-- / brand -->
            </div>
            <div class="hide-scroll"
                 data-flex>
                <nav class="scroll nav-border b-greenish">
                    <ul class="nav mt-4"
                        ui-nav>
                        <router-link :to="{ name: 'Dashboard' }"
                                     tag="li"
                                     exact-active-class="active green-gradient rounded">
                            <a>
                                <span class="nav-icon">
                                    <i class="material-icons">person_pin</i>
                                </span>
                                <span class="nav-icon active">
                                    <i class="material-icons">person_pin</i>
                                </span>
                                <span class="nav-text">Dashboard</span>
                            </a>
                        </router-link>

                        <router-link :to="{ name: 'Pending Pre-signups' }"
                                     v-if="profile.regular_admin"
                                     tag="li"
                                     exact-active-class="active green-gradient rounded">
                            <a>
                                <span class="nav-icon">
                                    <i class="material-icons">perm_contact_calendar</i>
                                </span>
                                <span class="nav-icon active">
                                    <i class="material-icons">perm_contact_calendar</i>
                                </span>
                                <span class="nav-text">Pre-signups</span>
                            </a>
                        </router-link>

                        <template v-if="!profile.is_reseller">

                            <router-link :to="{ name: 'Billing' }"
                                         tag="li"
                                         v-if="profile.regular_admin"
                                         active-class="active green-gradient rounded"
                                         exact-active-class="active green-gradient rounded">
                                <a>
                                    <span class="nav-icon">
                                        <i class="material-icons">receipt</i>
                                    </span>
                                    <span class="nav-icon active">
                                        <i class="material-icons">receipt</i>
                                    </span>
                                    <span class="nav-text">Billing</span>
                                </a>
                            </router-link>

                            <li v-if="profile.queue_admin">
                                <a href="/fairqueue/dashboard"
                                   target="_blank">
                                    <span class="nav-icon">
                                        <i class="material-icons">flare</i>
                                    </span>
                                    <span class="nav-icon active">
                                        <i class="material-icons">flare</i>
                                    </span>
                                    <span class="nav-text">Fair-Queues</span>
                                </a>
                            </li>

                            <li v-if="profile.queue_admin">
                                <a href="/horizon/dashboard"
                                   target="_blank">
                                    <span class="nav-icon">
                                        <i class="material-icons">flare</i>
                                    </span>
                                    <span class="nav-icon active">
                                        <i class="material-icons">flare</i>
                                    </span>
                                    <span class="nav-text">Horizon</span>
                                </a>
                            </li>

                            <li v-if="profile.regular_admin">
                                <a href="https://docs.google.com/spreadsheets/d/1MwlT2D5kk4ZpcbALBYDdLpNDwzL7hxVkfmbtXTZ2dZY/edit#gid=1765594618"
                                   target="_blank">
                                    <span class="nav-icon">
                                        <i class="material-icons">attach_money</i>
                                    </span>
                                    <span class="nav-icon active">
                                        <i class="material-icons">attach_money</i>
                                    </span>
                                    <span class="nav-text">Open Deal Sizer</span>
                                </a>
                            </li>
                        </template>

                        <router-link :to="{ name: 'Support Tools' }"
                                     tag="li"
                                     v-if="profile.regular_admin"
                                     exact-active-class="active green-gradient rounded"
                                     active-class="active green-gradient rounded">
                            <a>
                                <span class="nav-icon">
                                    <i class="fa fa-wrench"></i>
                                </span>
                                <span class="nav-icon active">
                                    <i class="fa fa-wrench"></i>
                                </span>
                                <span class="nav-text">Support Tools</span>
                            </a>
                        </router-link>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../auth'
import {mapActions, mapState} from 'vuex'

export default {

    data() {
        return {
            profile: auth.user.profile,
            static_data: null,
            env: null,
        }
    },

    computed: {
        getLogo() {
            let logo = "/assets/images/logo.png"
            let logo_only = "/assets/images/logo-only.png"
            if (this.static_data) {
                logo = this.static_data.logo ? this.static_data.logo : logo
                logo_only = this.static_data.logo_square ? this.static_data.logo_square : logo_only
            }
            return {
                logo,
                logo_only
            }
        },

        ...mapState({
            sidebar_folded: state => state.cache.sidebar_folded
        })
    },

    beforeCreate() {
        axios.get('/build-info.json').then(res => {
            this.env = res.data.env
        }).catch(err => {
            console.log(err)
        })
    },

    created() {
        this.getWhitelabelStatus()
    },

    methods: {
        getWhitelabelStatus() {
            axios.get('/get-statics')
                .then(res => {
                    this.static_data = res.data
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
        },

        logout() {
            auth.logout()
                .then(res => {
                    this.response = res.data
                    this.resetCache()
                    window.location.href = '/login'
                })
                .catch(err => {
                    this.response = err.response.data.error
                })
        },

        ...mapActions('cache', ['resetCache'])
    }
}
</script>
